export type SendKey = "modifier-enter" | "enter";

export type SendKeyEvent = {
  key: string;
  isComposing: boolean;
  shiftKey: boolean;
  metaKey: boolean;
  ctrlKey: boolean;
  altKey: boolean;
};

export function matchesSendKey(event: SendKeyEvent, sendKey: SendKey): boolean {
  // IME 変換確定の Enter は送信にしない
  if (event.key !== "Enter" || event.isComposing) return false;
  if (sendKey === "enter") {
    return !event.shiftKey && !event.metaKey && !event.ctrlKey && !event.altKey;
  }
  return event.metaKey || event.ctrlKey;
}
